module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    staticClass: "modal-box"
  }, [_c('div', {
    staticClass: "context",
    on: {
      "click": _vm.closeModal
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "modal"
  }, [_c('img', {
    staticClass: "modal-close",
    attrs: {
      "src": require("../../assets/close.png")
    },
    on: {
      "click": _vm.closeModal
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-content"
  }, [_c('h4', {
    staticClass: "user-agree-title"
  }, [_vm._v("关于真相搜索")]), _vm._v(" "), _c('p', {
    staticClass: "user-agree-explain"
  }, [_vm._v("真相搜索是真相科技自主研发并掌握核心技术的全新交互式互联网搜索引擎，依托区块链、大数据、深度学习和云搜索等核心技术，按照被搜索数据的关键特征信息，深度挖掘比对全网海量文字、图片、音频和视频数据信息，通过对非结构化数据信息的分析，并结合机器学习和智能识别，快速在全网海量数据中查询到相似内容。")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("真相搜索范围覆盖网盘、微博、微信、企业网站、门户网站、各垂直内容网站以及电商平台等，可以进行客观全面的内容搜索，是获取全面信息的有效工具，同时，真相搜索结合深度学习技术，对搜索结果进行分析和预判，可以在海量互联网数据中及时发现违法违规以及侵权线索。对于搜索到的网络内容，真相搜索提供一键证据固定功能，该技术依托真相科技经过公安部警用与安全设备鉴定的云计算平台IP360的多项核心功能，系统将自动识别用户请求，并将动态或者静态网络内容固定成相应的电子证据，妥善解决权利人在互联网权益保护过程中的搜证、取证难题。")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": require("../../assets/aboutTruthso.png")
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("真相搜索具有完备的、便捷的取证功能，通过云端智能取证系统，用户可对搜索结果中的文字图片进行快照取证、音频和视频进行录制取证， 自主研发的基于云计算的高并发网页快照证据固化技术，可以针对网络内容进行每小时10万次的网页快照证据固化。基于云平台的智能互联网音视频自动取证技术，可以自动获取待取证的音频/视频网址中的内容，形成法律证据。真相搜索依托与真相保全云计算平台，该平台通过公安部警用与安全设备鉴定，涉及主体身份识别、512位非对称加密、北斗卫星时间系统以及可信云计算等综合性法律技术的运用，所有系统生成的电子证据均会与公安部数据保全系统进行数字指纹同步异地备份，严格保证证据生成的合法性、有效性。")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("真相搜索用户也可以通过用户中心直接使用真相科技的其他法律科技服务，详情请进入用户中心查看。")]), _vm._v(" "), _c('p', {
    staticClass: "item"
  }, [_vm._v("全网搜索，快速取证，就在全新交互式互联网搜索引擎--------- 真相搜索。")])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-48e6408e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/others/AboutTruthso.vue
// module id = 766
// module chunks = 1